// @flow
import TransferTokensForm from './TransferTokensForm';
import connect from './connect';

export default connect(TransferTokensForm);



// WEBPACK FOOTER //
// ./src/components/TransferTokensForm/index.js